import { ChevronDown } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '~/shared/lib/utils'

/**
 * A native `<details>` section: a one-line summary row that folds its content away.
 * `hint` is shown next to the title only while it is closed.
 */
export function Disclosure({
  title,
  hint,
  icon,
  defaultOpen,
  className,
  contentClassName,
  id,
  children,
}: {
  title: ReactNode
  hint?: ReactNode
  icon?: ReactNode
  defaultOpen?: boolean
  className?: string
  contentClassName?: string
  id?: string
  children: ReactNode
}) {
  return (
    <details id={id} open={defaultOpen} className={cn('group/disclosure', className)}>
      <summary className="flex cursor-pointer list-none items-center gap-2 rounded-md py-2 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden">
        {icon ? (
          <span className="shrink-0 text-muted-foreground [&_svg]:size-4">{icon}</span>
        ) : null}
        <span className="shrink-0 font-medium">{title}</span>
        {hint ? (
          <span className="min-w-0 flex-1 truncate text-muted-foreground group-open/disclosure:invisible">
            {hint}
          </span>
        ) : (
          <span className="flex-1" />
        )}
        <ChevronDown
          aria-hidden
          className="size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open/disclosure:rotate-180 motion-reduce:transition-none"
        />
      </summary>
      <div className={cn('pt-2 pb-1', contentClassName)}>{children}</div>
    </details>
  )
}
